import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-160" data-mp="21x25kbat0z3c">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-aqua/25 border-l-4 border-l-energy bg-navy-card p-4 pr-10 text-cream shadow-2xl" aria-live="polite" data-id="element-161" data-mp="21yvddtx5lpcx">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-haze transition-colors duration-150 ease-out hover:text-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Chiudi avviso" data-id="element-162" data-mp="hjtc9wktzdl2">
            <XIcon className="h-4 w-4" data-id="element-163" data-mp="1jeojue21rtjg" />
          </button>
          <div className="flex gap-3" data-id="element-164" data-mp="1nga4ilktpc47">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-energy" aria-hidden="true" data-id="element-165" data-mp="1nf8fteavwr40" />
            <div data-id="element-166" data-mp="19ntyrd0jezzl">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-energy" data-id="element-167" data-mp="19nbrzmg913df">Accesso confermato</p>
              <p className="mt-1 text-sm leading-snug text-haze" data-id="element-168" data-mp="zr8s6n8vdgtn">
                Una volta completato l&apos;acquisto riceverai la
                <br data-id="element-169" data-mp="14pk3l2etbzdz" />
                <span className="font-bold text-cream" data-id="element-170" data-mp="14r3fkgtfro9y">ENERGIE RINNOVABILI — Edizione Docenti</span>
              </p>
              <p className="mt-2 text-xs text-haze" data-id="element-171" data-mp="qrc7ewplp23v">Accesso digitale immediato via email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}